'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Sync = require('./sync');

var SyncDB = (function () {
    function SyncDB(options) {
        _classCallCheck(this, SyncDB);

        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object' || options === null) {
            throw new TypeError('options argument must be an object');
        }
        if (_typeof(options.driver) !== 'object') {
            throw new TypeError('driver option must be an object');
        }

        this._onGet = options.onGet || defaultOnGet;

        this._driver = options.driver;
        this._url = options.url ? options.url : '';
        this._limit = options.limit || 5;

        this._exec = null;
    }

    _createClass(SyncDB, [{
        key: 'sync',
        value: function sync() {
            var _this = this;

            if (this._exec) {
                return this._exec;
            }
            var exec = new Sync(this._driver, this._url, this._limit);
            this._exec = exec;

            exec.then(function () {
                _this._exec = null;
            });
            return exec;
        }
    }, {
        key: 'insert',
        value: function insert(docID, document) {
            var _this2 = this;

            return this._driver.get(docID).then(function (doc) {
                if (!doc) {
                    doc = {
                        id: docID,
                        seqid: -1
                    };
                }
                doc.revid = (doc.revid || 0) + 1;
                doc.date = Date.now();
                doc.value = document;
                return _this2._driver.insert(doc);
            });
        }
    }, {
        key: 'remove',
        value: function remove(docID) {
            throw new Error('remove is unimplemented');
            //return this._driver.remove(docID);
        }
    }, {
        key: 'get',
        value: function get(docID) {
            return this._driver.get(docID).then(this._onGet);
        }
    }, {
        key: 'getData',
        value: function getData() {
            var _this3 = this;

            return this._driver.getData().then(function (docs) {
                return docs.map(_this3._onGet);
            });
        }
    }, {
        key: 'clearDatabase',
        value: function clearDatabase() {
            return this._driver.clearDatabase();
        }
    }]);

    return SyncDB;
})();

module.exports = SyncDB;

function defaultOnGet(dbObject) {
    return dbObject.value;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/sync-db/lib/index.js
 ** module id = 1
 ** module chunks = 0
 **/